"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _beam = require("beam");
var _SubMenu = _interopRequireDefault(require("./SubMenu"));
var _detectBrowser = require("detect-browser");
var _reactI18next = require("react-i18next");
var _utils = require("../../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const useStyles = (0, _beam.makeStyles)(theme => ({
  root: {
    display: 'flex',
    position: 'relative',
    height: theme.spacing(6),
    alignItems: 'center'
  },
  menuPanel: {
    flexGrow: 1,
    position: 'absolute',
    top: theme.spacing(5.5)
  },
  subMenuItem: {
    position: 'relative',
    overflow: 'visible',
    fontSize: 14,
    paddingRight: 32
  },
  chevronIcon: {
    color: (0, _utils.hexToRgbaStyle)(theme.palette.navigationTextColor, 0.7),
    //
    '&:hover': {
      color: theme.palette.navigationTextColor // TODO: provide `navigationTextColor` from the interface used by `theme.palette`
    }
  },

  subMenuIcon: {
    position: 'absolute',
    right: 0,
    top: '25%'
  }
}));
const OverflowMenu = /*#__PURE__*/(0, _react.forwardRef)(({
  menuItems
}, ref) => {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const classes = useStyles();
  const [open, setOpen] = (0, _react.useState)(false);
  const [expandedMenuItem, setExpandedMenuItem] = (0, _react.useState)(null);
  const handleMouseEnter = () => setOpen(true);
  const handleClick = () => setOpen(true);
  const handleMouseLeave = () => closeMenu();
  const handleSubMenuOpened = menuItem => setExpandedMenuItem(menuItem.key);
  const closeMenu = () => {
    setOpen(false);
    setExpandedMenuItem(null);
  };
  const renderItems = items => {
    return items.map(item => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_beam.MenuItem, {
      className: classes.subMenuItem,
      component: 'a',
      href: item.url,
      target: item.external ? '_blank' : undefined,
      rel: item.external ? 'noopener' : undefined,
      onMouseEnter: () => handleSubMenuOpened(item),
      "auto-qa-id": `OverflowMenu-${item.key}`,
      "data-testid": `OverflowMenu-${item.key}`,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_beam.ListItemText, {
        primary: t(item.key) /* TODO: remove `any` and fix the type error */
      }), item?.children?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_beam.BeamIcon, {
          className: classes.subMenuIcon,
          children: "ChevronRight"
        }), expandedMenuItem === item.key && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubMenu.default, {
          menuItems: item.children
        })]
      })]
    }, item.key));
  };

  /* Internet Explorer renders the top left corner of the <Paper> element at the bottom right
   * corner of it's parent element making it very difficult to hover over. This function returns
   * styling to shift the position of the element to better line up with its parent.
   * Works in Internet Explorer 6-11. http://jira/browse/SAAS-51568 */
  const browserDependentStyling = () => {
    const browserName = (0, _detectBrowser.detect)()?.name;
    if (browserName === 'ie') {
      return {
        left: 0
      }; // IE adds something called offset, in addition to margin & padding (hence the top left corner rendering issue). By setting left: 0, the offset is removed
    } else {
      return {};
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: classes.root,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_beam.IconButton, {
      className: classes.chevronIcon,
      ref: ref,
      onClick: handleClick,
      "auto-qa-id": 'OverflowMenu-button',
      "data-testid": 'OverflowMenu-button',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_beam.BeamIcon, {
        children: "ChevronDown"
      })
    }), open && /*#__PURE__*/(0, _jsxRuntime.jsx)(_beam.Paper, {
      className: classes.menuPanel,
      style: browserDependentStyling(),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_beam.MenuList, {
        dense: true,
        children: renderItems(menuItems)
      })
    })]
  });
});
var _default = exports.default = OverflowMenu;
//# sourceMappingURL=OverflowMenu.js.map